import { getDedicatedCalendarAccounts } from '@frontend/api-client';
import { calendarAndGmailReadonlyScopes } from '@frontend/constants';
import { useMemo } from '@frontend/react';
import { YStack } from '@frontend/web-react';
import { Calendar } from '@frontend/web/components';
import { useListOAuthAccountsQuery, useRetrieveClientQuery } from '@frontend/web/hooks';

export const CalendarCard = () => {
  const { data: client } = useRetrieveClientQuery();
  const { data: oAuthAccounts, isLoading, refetch: refetchOAuthAccounts } = useListOAuthAccountsQuery();

  const integratedCalendar = useMemo(
    () => getDedicatedCalendarAccounts(oAuthAccounts)?.find((o) => o.client === client?.id),
    [client?.id, oAuthAccounts],
  );

  const completedAllIntegrations = Boolean(integratedCalendar);

  if (completedAllIntegrations || isLoading) return null;
  return (
    <YStack gap="md">
      <Calendar
        integratedCalendar={integratedCalendar}
        purposes={['calendar', 'gmail']}
        refetchOAuthAccounts={refetchOAuthAccounts}
        scopes={calendarAndGmailReadonlyScopes}
      />
    </YStack>
  );
};
